export const Exercise = {
  bindings: {
    data: '<',
    workout: '<',
    exercise: '<',
    gender: '<',
    params: '<',
    index: '<',
    onClick: '&',
  },

  template: `
    <div class="exercise">
      <div class="exercise-content">
        <div ng-if="$ctrl.exercise.video.brightcoveId">
          <a class="exercise-thumb d-block"
            href="#"
            data-toggle="modal"
            data-target="#modalVideoExercise"
            ng-attr-title="Demo - {{ $ctrl.exercise.name }}"
            ng-click="$ctrl.onClick({ item: $ctrl.exercise.video })">
            <span class="fa-wrapper">
              <i class="fa fa-play"></i>
            </span>
            <img ng-src="{{ $ctrl.exercise.icon.thumb2x | assetSrc }}"/>
          </a>
        </div>
        <div ng-if="!$ctrl.exercise.video.brightcoveId">
          <img ng-src="{{ $ctrl.exercise.icon.thumb2x | assetSrc }}"/>
        </div>
        <section>
          <h4>
            <a
              ng-if="$ctrl.workout.autoplayable"
              ui-sref="workoutPlayer({ exercisePlanId: $ctrl.params.exercisePlanId, id: $ctrl.params.id, itemId: $ctrl.data.id })"
              brightcove-supported="replace">
              {{ $ctrl.exercise.name }}
            </a>
            <span ng-if="!$ctrl.workout.autoplayable">
              {{ $ctrl.exercise.name }}
            </span>
          </h4>
          <ul class="workout-stats">
            <li ng-if="$ctrl.data.totalTimeSet">
              <small>Time</small>
              <b>{{ $ctrl.data.totalTimeDigital }}</b>
            </li>
            <li ng-if="$ctrl.data.levelNumber || $ctrl.data.level" class="dash">
              <small>Level</small>
              <b>{{ $ctrl.data.levelNumber || $ctrl.data.level }}</b>
            </li>
            <li ng-if="$ctrl.data.inclineNumber || $ctrl.data.incline" class="dash">
              <small>Incline</small>
              <b>{{ $ctrl.data.inclineNumber || $ctrl.data.incline }}</b>
            </li>
            <li ng-if="$ctrl.data.speedKms || $ctrl.data.speedMetric" class="dash">
              <small>Speed</small>
              <b>{{ $ctrl.data.speedMetric || $ctrl.data.speedKms }}</b>
            </li>
            <li ng-if="$ctrl.data.distanceKms || $ctrl.data.distanceMetric" class="dash">
              <small>Distance</small>
              <b>{{ $ctrl.data.distanceMetric || $ctrl.data.distanceKms }}</b>
            </li>
            <li ng-if="$ctrl.data.sets || $ctrl.data.setsCount" class="times">
              <small>Sets</small>
              <b>{{ $ctrl.data.setsCount || $ctrl.data.sets }}</b>
            </li>
            <li ng-if="$ctrl.data.reps || $ctrl.data.repsCount" class="times">
              <small>Reps</small>
              <b>{{ $ctrl.data.repsCount || $ctrl.data.reps }}</b>
            </li>
            <li ng-if="$ctrl.data.weightBase" class="times">
              <small>Weight</small>
              <b>
                {{ $ctrl.data.weightBase | convertWeight: $ctrl.gender }}
                <span ng-show="$ctrl.data.weightRange">
                  -{{ $ctrl.data.weightBase + $ctrl.data.weightRange | convertWeight: $ctr.gender }}
                </span>
                kg
              </b>
            </li>
          </ul>
          <div>
            <span ng-show="$ctrl.data.note" ng-bind-html="$ctrl.data.note" class="note"></span>
            <span ng-show="$ctrl.data.formattedNote" class="note">
              {{ $ctrl.data.formattedNote }}
            </span>
          </div>
        </section>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Exercise/Exercise.js